TrameValidator.$inject = ['validator'];

export default function TrameValidator(validator) {
    const instance = new validator();

    //TODO FGZ s'assurer des règles de validations
    instance.ruleFor('code').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    instance.ruleFor('code').length(1, 15).withMessage('VALIDATION_TOO_LONG_15');
    instance
        .ruleFor('code')
        .matches(/^[a-zA-Z0-9_|]*$/)
        .withMessage('CODE_CHARACTERS_NOK');

    instance.ruleFor('codeExists').notEqual(true).withMessage('VALIDATION_NOTEMPTY');

    instance.ruleFor('nom').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    instance.ruleFor('nom').length(1, 100).withMessage('VALIDATION_TOO_LONG_DESCRIPTION');

    instance.ruleFor('typeId').notEmpty().withMessage('VALIDATION_NOTEMPTY');

    return instance;
}
